
<div class="view">
  <div class="view-label">{{this.label}}</div>
  <div class="content-wrapper"><ng-content></ng-content></div>
  <div class="no-content">
    -
  </div>
</div>
